import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 11",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.183 0.390 C 1.147 0.398,1.047 0.452,0.962 0.509 C 0.599 0.751,0.470 1.219,0.663 1.589 C 0.702 1.665,2.539 3.525,5.156 6.139 C 9.952 10.929,9.632 10.633,10.000 10.633 C 10.368 10.633,10.048 10.929,14.844 6.139 C 17.461 3.525,19.298 1.665,19.337 1.589 C 19.532 1.216,19.402 0.755,19.032 0.503 C 18.903 0.414,18.828 0.389,18.652 0.375 C 18.218 0.340,18.565 0.027,14.058 4.529 L 10.000 8.583 5.958 4.543 C 2.800 1.386,1.884 0.488,1.767 0.435 C 1.624 0.371,1.354 0.350,1.183 0.390 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretDown;
